import { memo } from 'react';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import {
    ALIGN_TYPE,
    DEVICES,
    DOMAIN_URL,
} from '@zmedia/bm-soccer-ui/constants';
import { IContent } from '@zmedia/bm-soccer-ui/interface';
import { DeviceUtils } from '@zmedia/bm-soccer-ui/utils';
import { formatTime } from '@zmedia/bm-soccer-ui/utils/date';
import {
    Card,
    Element,
    Image,
    LazyloadImage,
    RouterLink,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

interface IProps {
    item: IContent;
    align?: ALIGN_TYPE;
    publishedDate?: number;
    showSapo?: boolean;
}

const NoSsr = ({ item }: { item: any }) => (
    <Element renderAs="time" className={styles['content-tiem']}>
        {formatTime(item.publishedDate, ' trước')}
    </Element>
);

const PublishedTime = dynamic(() => Promise.resolve(NoSsr), {
    ssr: false,
});

export function ContentItem({ item, align, showSapo = false }: IProps) {
    const onClick = (evt: React.MouseEvent) => {
        const isDesktop = DeviceUtils.getDevice() === DEVICES.DESKTOP;
        if (isDesktop) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        const _window: any = window;
        if (_window.AdtimaBaomoi) {
            _window.AdtimaBaomoi.config._reqid = 0;
        }
    };

    return (
        <Card
            className={cn(styles['soccer-content-item'], {
                [styles[`is-${align}`]]: align,
            })}
        >
            <Card.Image>
                <RouterLink
                    to={`${DOMAIN_URL}${item.url}`}
                    onClick={onClick}
                    title={item.title}
                    newTab
                >
                    <LazyloadImage src={item.thumbM} />
                </RouterLink>
            </Card.Image>
            <Card.Content>
                <Title>
                    <RouterLink
                        to={`${DOMAIN_URL}${item.url}`}
                        onClick={onClick}
                        title={item.title}
                        newTab
                    >
                        {item.title}
                    </RouterLink>
                </Title>
                <Card.Footer>
                    {item?.publisher?.logo ? (
                        <Element
                            renderAs="span"
                            className={styles['bm-card-source']}
                        >
                            <Image src={item?.publisher?.logo} />
                        </Element>
                    ) : (
                        <Element
                            renderAs="span"
                            className={styles['bm-card-source']}
                        >
                            <Image src={item?.publisher?.icon || ''} />
                            <Element renderAs="span">
                                {item.publisher?.name}
                            </Element>
                        </Element>
                    )}

                    {item.publishedDate && <PublishedTime item={item} />}
                </Card.Footer>
                {showSapo && (
                    <Element className={styles['description']}>
                        {item.description}
                    </Element>
                )}
            </Card.Content>
        </Card>
    );
}

export default memo(ContentItem);
